<!--
 * @Author: 李鸿润
 * @Date: 2021-07-22 10:11:19
 * @LastEditTime: 2021-08-02 18:29:32
 * @LastEditors: Please set LastEditors
 * @Description: 后勤组织架构设计与职责分工
 * @FilePath: \hpss-ui\src\views\crmedical\value\valuedeclare\logisticsDesgin.vue
-->
<template>
    <div id="design">
        <h2>
            后勤组织架构设计与职责分工
        </h2>
         <div>
              <el-form :model="budgetDept" ref="budgetDeptRef" >
                <el-table :data="budgetDept" style="" class="table1" >
                    <el-table-column
                    type="index"
                    label="序号"
                    width="50">
                    </el-table-column>
                    <el-table-column
                        prop="deptName"
                        label="组织"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.deptName'" :rules="[
                             { required: true, message: '组织名称不能为空', trigger: 'blur' },
                            ]" >
                            <el-input v-model="scope.row.deptName" placeholder="请输入内容"  maxlength="30"></el-input>
                            </el-form-item>
                            
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="deptUserNum"
                        label="人数"
                        width="180">
                        <template slot-scope="scope">
                          <!-- { type: 'number', message: '人员必须为数字值',trigger:'blur'}, -->
                            <el-form-item :prop="scope.$index+'.deptUserNum'" :rules="[
                              { required: true, message: '人数不能为空', trigger: 'blur' },
                              
                              
                              rule1,
                            ]">
                                <el-input  v-model="scope.row.deptUserNum"  maxlength="6" placeholder="请输入内容"></el-input>
                            </el-form-item>
                            
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="dutyDescription"
                        label="职责"
                        width="600">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.dutyDescription'" :rules="[
                                { required: true, message: '描述不能为空', trigger: 'blur' },
                            ]">
                                <el-input v-model="scope.row.dutyDescription" placeholder="请输入内容"  maxlength="50"></el-input>
                            </el-form-item>
                            
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="postName"
                        label="岗位"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.postName'" :rules="[
                              { required: true, message: '岗位名称不能为空', trigger: 'blur' },
                            ]" >
                                <el-input v-model="scope.row.postName" placeholder="请输入内容"  maxlength="30"></el-input>
                            </el-form-item>
                           
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="操作"
                        width="100">
                        <template slot-scope="scope" v-if='budgetDept.length>1'>
                            <el-button @click="remove(budgetDept,scope.row.index)" >删除</el-button>                 
                        </template>
                    </el-table-column>
                </el-table>
              </el-form>
         </div>
         <div>
            <button class="btn" @click="add(budgetDept)">+</button>
        </div>
        <VueEditor style="margin-top:20px" id="editor"  v-model="form.deptDescription" useCustomImageHandler  @image-added="handleImageAdded"></VueEditor>
    </div>
</template>

<script>
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import { putFile } from '@/api/crmedical/contract/add';
import { saveOrganization } from '@/api/crmedical/value/valuebudget';
export default {
  props: {
    editDetailInfo: {},
  },
  components: {
    VueEditor,
  },
  data() {
    // var validatePass = (rule, value, callback) => {
    //   console.log('验证');
    //   let reg = /^[0-9]+$/;
    //   if (reg.test(value)) {
    //     callback();
    //   } else {
    //     callback(new Error('请输入数字'));
    //   }
    // };
    var peopleNumber = (rule, value, callback) => {
       let reg = /^[0-9]+$/;
      if (reg.test(value)) {
        if (Number(value)>0) {
        callback();
      } else {
        callback(new Error('人数不能小于0'));
      }
      } else {
        callback(new Error('请输入大于0数字'));
      }
      
    };
    return {
      rule1: { validator: peopleNumber, trigger: 'blur' },
      refList: ['budgetDeptRef'],
      validateFlag: false, //表单验证状态
      form: {
        deptDescription: '',
      },
      budgetDeptRules: {
        deptName: [{ required: true, message: '组织名称不能为空', trigger: 'blur' }],
        deptUserNum: [{ required: true, message: '人数不能为空', trigger: 'blur' }],
        dutyDescription: [{ required: true, message: '描述不能为空', trigger: 'blur' }],
        postName: [{ required: true, message: '岗位名称不能为空', trigger: 'blur' }],
      },
      budgetDept: [
        {
            deptName:'',
            deptUserNum:'',
            dutyDescription:'',
            postName:'',
            index:0
        },
      ],
      addForm: {
        deptName: '',
        deptUserNum: '',
        dutyDescription: '',
        postName: '',
        index: 0,
      },
    };
  },
  created() {
    this.initdata();
  },
  methods: {
    
    initdata() {
      let arry = this.editDetailInfo['valueBudgetDeptInfos'];
      if (arry && arry.length > 0) {
        this.budgetDept =[]
        arry.forEach((item) => {
          item.index = this.budgetDept.length;
          this.budgetDept.push(item);
        });
      }
      // 富文本
      this.form.deptDescription = this.editDetailInfo['deptDescription'];
    },
    add(data) {
      this.addForm.index = this.addForm.index + 1;
      data.push(Object.assign({}, this.addForm));
    },
    remove(data, index) {
      let tagIndex;
      for (let i = 0; i < data.length; i++) {
        if (data[i].index == index) {
          tagIndex = i;
        }
      }
      if (data.length > 1) {
        data.splice(tagIndex, 1);
      }
    },
    // 富文本处理图片上传问题
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      if (this.VueEditorDisabled) {
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //（保存）提交
    async submit() {
      let flag1;
      this.$refs['budgetDeptRef'].validate((valid) => {
        if (valid) {
          flag1 = true;
        } else {
          flag1 = false;
        }
      });

      this.validateFlag = flag1 ? true : false;
      this.refList.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (valid) {
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      });
      if (this.validateFlag) {
        await saveOrganization(
          Object.assign({
            valueBudgetDeptInfos: this.budgetDept,
            deptDescription: this.form.deptDescription,
            id: this.editDetailInfo.id,
          })
        ).then(({ code }) => {
          if (code == 200) {
            this.$message({
              showClose: true,
              message: '数据保存成功',
              type: 'success',
            });
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: '请将数据填写完整',
          type: 'error',
        });
         this.validateFlag= false;
      }
       return this.validateFlag;
    },
  },
};
</script>

<style scoped>
.table1 {
  width: 100%;
  margin: 20px auto;
}
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
}
.btn::after {
  display: none;
}

</style>
<style>
#design .el-form-item__error {
  top: 26px;
}
</style>

